import React, { Component, Fragment } from 'react'
import Showcase from 'Catalog/Showcase'
import Helmet from 'react-helmet'

import '@loyal_template/points_and_cash.css'
import { features, ToggleFeature } from 'features/ToggleFeature'

class PointsAndCash extends Component {
  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Pontos + ${process.env.REACT_APP_PAYMENT_COMPLEMENT_TEXT || 'Dinheiro'} - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='px-0 bg-ui-4'>
          <div className='bg-pointsandcash container-fluid'>
            <div className='container h-100'>
              <div className='row h-100 align-items-center'>
                <div className='col-12'>
                  <h2 className='color-ui-white txt-title-2 txt-circular-black txt-center txt-md-left'>
                    Conheça a melhor forma{' '}
                    <br className='d-none d-md-inline-block' />
                    de resgatar seus prêmios.{' '}
                    <br className='d-none d-md-inline-block' />
                    <span className='color-brand-6'>Pontos</span> +{' '}
                    <span className='color-brand-6'>{process.env.REACT_APP_PAYMENT_COMPLEMENT_TEXT || 'dinheiro'}</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className='container not-found'>
            <ToggleFeature feature={features.PointsAndCash} />
            <Showcase showcaseType='5' identifier='home' />
            <Showcase showcaseType='7' identifier='home' />
          </div>

        </div>
      </Fragment>
    )
  }
}

export default PointsAndCash



// WEBPACK FOOTER //
// ./src/features/PointsAndCash/PointsAndCash.js